export default __webpack_public_path__ + "static/media/Map.1a18074b.svg";